import { useLang } from "@/i18n/LanguageContext";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";

const FAQ = () => {
  const { t } = useLang();
  return (
    <section className="py-24 md:py-32 bg-soft border-t border-border">
      <div className="container max-w-3xl">
        <h2 className="text-4xl md:text-5xl font-semibold leading-tight text-center">{t.faq.title}</h2>
        <Accordion type="single" collapsible className="mt-12">
          {t.faq.items.map((item, i) => (
            <AccordionItem key={i} value={`item-${i}`} className="border-border">
              <AccordionTrigger className="text-left text-base font-semibold hover:no-underline">
                {item.q}
              </AccordionTrigger>
              <AccordionContent className="text-muted-foreground leading-relaxed">
                {item.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
};

export default FAQ;
